/**
 * WordPress dependencies
 */
import { useSelect } from '@safe-wordpress/data';
import { Dashicon } from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { store as NAB_DATA } from '@nab/data';

/**
 * Internal dependencies
 */
import './style.scss';

export const NoQuotaWarning = (): JSX.Element | null => {
	const quota = useSelect( ( select ) => select( NAB_DATA ).getQuota(), [] );
	if ( ! quota || quota.availableQuota ) {
		return null;
	}

	return (
		<div className="nab-overview__no-quota-warning">
			<Dashicon icon="warning" />
			{ _x(
				'Event tracking has stopped because there’s no more quota available at the moment',
				'text',
				'nelio-ab-testing'
			) }
		</div>
	);
};
